import React from 'react';
import PropTypes from 'prop-types';
import {StyledLogo, StyledLogoImg} from './Styles';

function Logo({
  alt,
  height = 'auto',
  src,
  srcMobile = undefined,
  width = '150px',
}) {
  return (
    <StyledLogo height={height} width={width}>
      <picture>
        {srcMobile && <source media="(max-width: 767px)" srcSet={srcMobile} />}
        <StyledLogoImg alt={alt} src={src} />
      </picture>
    </StyledLogo>
  );
}

Logo.propTypes = {
  /**
   * Alt text to display if image link is broken
   */
  alt: PropTypes.string.isRequired,

  /**
   * Defines the height of logo
   */
  height: PropTypes.string,

  /**
   * Image link
   */
  src: PropTypes.string.isRequired,

  /**
   * Image link for mobile devices
   */
  srcMobile: PropTypes.string,

  /**
   * Defines the width of logo
   */
  width: PropTypes.string,
};

Logo.defaultProps = {
  height: 'auto',
  srcMobile: '',
  width: '150px',
};

export default Logo;
